var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSchoolFilled = function SvgSchoolFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 15.9v-6L12.8 14q-.375.2-.8.2t-.8-.2L2.8 9.8a.87.87 0 0 1-.5-.8q0-.25.125-.462A.87.87 0 0 1 2.8 8.2L11.2 4q.2-.1.4-.15a1.65 1.65 0 0 1 .8 0q.2.05.4.15l9.5 4.75q.224.125.363.325a.8.8 0 0 1 .137.475v6.35q0 .375-.262.638a.87.87 0 0 1-.638.262.87.87 0 0 1-.637-.262A.87.87 0 0 1 21 15.9M11.2 20l-4.8-2.4q-.45-.224-.725-.663A1.73 1.73 0 0 1 5.4 16v-2.875l5.8 2.9q.375.2.8.2t.8-.2l5.8-2.9V16q0 .5-.275.938a1.8 1.8 0 0 1-.725.662L12.8 20a2 2 0 0 1-.4.15 1.64 1.64 0 0 1-.8 0 2 2 0 0 1-.4-.15"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSchoolFilled);
export default ForwardRef;